// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PQrcodeOutlinedSvg from "@fishx/icons-svg/es/asn/PQrcodeOutlined";
import FishxIcon from '../components/FishxIcon';

var PQrcodeOutlined = function PQrcodeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PQrcodeOutlinedSvg
  }));
};

PQrcodeOutlined.displayName = 'PQrcodeOutlined';
export default React.forwardRef(PQrcodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PQrcodeOutlined.js
// module id = 3559
// module chunks = 0